import { render } from "./Login.vue?vue&type=template&id=23bd5d43&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=23bd5d43&scoped=true&lang=css"

import exportComponent from "/Users/beerebeerey/github-classroom/MUICCS/cs340prj-beersilver/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23bd5d43"]])

export default __exports__